import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { userTaskAddNumApi } from "@/api/openBlind";
import { activityId } from "@/views/roki/yearEndOpenBlindBox/data/index";
import { urlLink } from "@/utils/request";
const state = {
  shareUrl: "",
  timestamp: "",
  fingerId: "",
  answerQuestionScore: 0,
  answerNickName: "",
  userFlagList: [], //当前用户最终的的flag清单
  flagSignature: "", //flag签名
  aiShareCookbookId: null,
  aiGenerateNickName: null
};
const mutations = {
  SET_FINGERID: (state, fingerId) => {
    state.fingerId = fingerId;
  },
  
};

const actions = {
  userAddNum({ commit, state },taskType){
    userTaskAddNumApi({activityId,taskType}).then(res=>{
        console.log('taskType---增加次数---',taskType,res);
    })
  },  
  async getShareUrl({ commit, state }) {
    const options = {
      excludes: { enumerateDevices: false }
    };
    const fp = await FingerprintJS.load(options);
    const result = await fp.get();
    const visitorId = result.visitorId;
    commit("SET_FINGERID", visitorId);
    var currentTimeStamp = Date.now();
    commit("SET_TIMESTAMP", currentTimeStamp);
    
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/blind.js